const SDK_VERSION = '8.10.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
